import { Button, Col, Input, notification, Row } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import TmsDatePickerRange from "../../../../components/tms-customs/tms-datepicker-range";
import TmsExcelButton from "../../../../components/tms-customs/tms-excel-button";
import TmsSelect from "../../../../components/tms-customs/tms-select";
import TmsTable from "../../../../components/tms-customs/tms-table";
import TmsCounterService from "../../../../services/tms-counter.service";
import TmsKalayanakattaService from "../../../../services/tms-kalayanakatta.service";
import TmsShiftService from "../../../../services/tms-shift.service";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import catchErrorFunction from "../../../../utils/tms-catch-error/tms-catch-error";
import { exportExcel } from "../../../../utils/tms-excel/tms-excel";
import "../../../../assets/css/tms-reports/tms-reports.scss";

const TmsReportKalyanakattaReport = ({ router }) => {
  const [loading, setLoading] = useState();
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);
  const [bookingDetails, setBookingDetails] = useState([]);
  const [bookingType, setBookingType] = useState("POS");
  const [counter, setCounter] = useState("");
  const [counterList, setCounterList] = useState([]);
  const [shift, setShift] = useState("");
  const [shiftList, setShiftList] = useState([]);
  const [bookingFromDate, setBookingFromDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [bookingToDate, setBookingToDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [kalyankattaList, setKalyanakattaList] = useState([]);
  const [kalyankattaType, setKalyankattaType] = useState("");
  const [performerList, setPerformerList] = useState([]);
  const [performerId, setPerformerId] = useState("");

  const [excelLoading, setExcelLoading] = useState(false);

  useEffect(() => {
    fetchKalyanakattaList();
    fetchCounterList();
    fetchShiftList();
  }, []);

  useEffect(() => {
    fetchPerformer();
  }, [counter]);

  useEffect(() => {
    fetchBookingDetails();
  }, [
    bookingFromDate,
    bookingToDate,
    tableCurrentPage,
    tablePageSize,
    counter,
    shift,
    kalyankattaType,
    performerId,
  ]);

  const fetchBookingDetails = async () => {
    setLoading(true);
    try {
      const data = await TmsKalayanakattaService.kalayanakattaReport(
        "json",
        Number(tableCurrentPage),
        Number(tablePageSize),
        bookingFromDate,
        bookingToDate,
        counter,
        shift,
        kalyankattaType,
        performerId
      );
      setTabelTotalSize(data?.meta?.totalItems);
      setBookingDetails(
        data?.items?.map((item) => {
          return { key: item?.bookingId, ...item };
        })
      );
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
    setLoading(false);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          // ref={node => {
          //   this.searchInput = node;
          // }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        // setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };

  const columns = [
    {
      title: "S.no",
      key: "sno",
      width: "20px",
      render: (text, object, index) => index + 1,
    },
    {
      title: "POS Name",
      dataIndex: "counterName",
      key: "counterName",
    },
    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "User ID",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "Shift Id",
      dataIndex: "counterShiftTimingId",
      key: "counterShiftTimingId",
    },
    {
      title: "Booking Id",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Txn Id",
      dataIndex: "categoryTransactionSequence",
      key: "categoryTransactionSequence",
    },
    {
      title: "Tronsure Type",
      dataIndex: "kalyanakattaName",
      key: "kalyanakattaName",
      ...getColumnSearchProps("kalyanakattaName"),
    },
    {
      title: "Performer",
      dataIndex: "performerName",
      key: "performerName",
    },
    {
      title: "Booking Date",
      dataIndex: "createdDate",
      render: (record) => {
        return moment(record).format("DD-MM-YYYY");
      },
      sorter: (a, b) => a.createdDate > b.createdDate,
    },
    {
      title: "Price",
      dataIndex: "productPrice",
      key: "productPrice",
      render: (text) => {
        return `Rs. ${text}`;
      },
      sorter: (a, b) => a.price > b.price,
    },
  ];

  const fetchCounterList = async () => {
    try {
      let res = await TmsCounterService.getAllCounter();
      setCounterList(res?.items);
    } catch (e) {
      notification.error({ message: e?.message });
    }
  };

  const fetchShiftList = async () => {
    try {
      let res = await TmsShiftService.getAllShifts();
      setShiftList(res?.items);
    } catch (e) {
      notification.error({ message: e?.message });
    }
  };

  const fetchKalyanakattaList = async () => {
    try {
      let res = await TmsKalayanakattaService.getKalayanakatta(1, 100);
      setKalyanakattaList(res.items);
    } catch (e) {
      notification.error({ message: e?.message });
    }
  };

  const fetchPerformer = async () => {
    try {
      if (counter) {
        let res = await TmsKalayanakattaService.getKalayanakattaPerformers(
          1,
          100,
          Number(counter)
        );
        setPerformerList(res.items);
      } else {
        let res = await TmsKalayanakattaService.getKalayanakattaPerformers(
          1,
          100
        );
        setPerformerList(res.items);
      }
    } catch (e) {
      notification.error({ message: e?.message });
    }
  };

  const handleExcelExport = async () => {
    setExcelLoading(true);
    try {
      const data = await TmsKalayanakattaService.kalayanakattaReport(
        "json",
        Number(tableCurrentPage),
        Number(50000),
        bookingFromDate,
        bookingToDate,
        counter,
        shift,
        kalyankattaType,
        performerId
      );

      const compiledData = data.items.map((item, i) => {
        return {
          "S.no": i + 1,
          "POS Name": item.counterName,
          "User Name": item.userName,
          "User ID": item.userId,
          "Shift ID": item.counterShiftTimingId,
          "Booking Id": item.bookingId,
          "Transaction Id": item?.categoryTransactionSequence
            ?.split("-")
            ?.pop(),
          "Tronsure Type": item.kalyanakattaName,
          Performer: item.performerName,
          "Booking Date": item.createdDate
            ? moment(item.createdDate).format("DD-MM-YYYY")
            : "-",
          Price: item.productPrice,
        };
      });
      exportExcel(
        compiledData,
        `kalyankatta-report-${moment().format("DD-MM-YYYY")}`,
        setExcelLoading
      );
    } catch (error) {
      catchErrorFunction(error, "Token expired!! Please login again.", router);
      setExcelLoading(false);
    }
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <TmsSelect
          type="col"
          span={3}
          label="Booking Type"
          setValue={setBookingType}
          value={bookingType}
          data={[
            { id: "pos", name: "pos" },
            { id: "online", name: "online" },
          ]}
        />
        <TmsSelect
          type="col"
          span={3}
          label="POS"
          setValue={setCounter}
          value={counter}
          data={counterList}
        />
        <TmsSelect
          type="col"
          span={3}
          label="Shift"
          setValue={setShift}
          value={shift}
          data={shiftList}
        />
        <TmsSelect
          type="col"
          span={3}
          selectClass="w-100"
          label="Tonsure Type"
          setValue={(e) => {
            setKalyankattaType(e);
          }}
          value={kalyankattaType}
          data={kalyankattaList}
        />
        <TmsSelect
          type="col"
          span={3}
          selectClass="w-100"
          label="Performer"
          setValue={(e) => {
            setPerformerId(e);
          }}
          value={performerId}
          data={performerList}
        />
        <Col span={6}>
          <TmsDatePickerRange
            className={"m-0"}
            label="Time period"
            to={bookingToDate}
            from={bookingFromDate}
            setFrom={setBookingFromDate}
            setTo={setBookingToDate}
          />
        </Col>
        <TmsExcelButton
          loading={excelLoading}
          handleExcelExport={handleExcelExport}
          top={true}
        />
      </Row>
      <br />
      <Row>
        <TmsTable
          columns={columns}
          dataSource={bookingDetails}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={{
            total: tableTotalSize,
            current: tableCurrentPage,
            pageSize: tablePageSize,
          }}
        ></TmsTable>
      </Row>
    </>
  );
};

export default withRouter(TmsReportKalyanakattaReport);
